import React from "react";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Popconfirm } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import filterTypes from "data/filter-types";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import { triggerSearch, triggerDelete } from "actions/bike-scan-trigger/actions";
import { getSingleBikeByFilters } from "actions/bike/actions";
import Filters from "./filters";
import CreateModal from "./create-modal";

class BikesScanTrigger extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: [],
      page: 0,
      size: 30,
      sort: "id,asc"
    };

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSortedChange = this.handleSortedChange.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
    this.getColumns = this.getColumns.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);

    this.props.triggerSearch();
  }

  handleSearch = (filters) => {
    this.setState({
      filters,
      page: 0,
    }, this.handleLoad);
  };

  handleReset = () => {
    this.handleSearch([]);
  };

  handlePageChange = (page) => {
    this.setState({
      page
    }, this.handleLoad);
  };

  handleSortedChange = (sorted) => {
    this.setState({
      sort: `${sorted[0].id},${sorted[0].desc ? "desc" : "asc"}`
    }, this.handleLoad);
  };

  handlePageSizeChange = (size) => {
    this.setState({
      size,
      page: 0,
    }, this.handleLoad);
  };

  handleLoad = () => {
    const {
      page,
      size,
      sort,
      filters
    } = this.state;

    this.props.triggerSearch(page, size, sort, filters);
  };

  handleCreate = (id = false) => {
    const modalObj = {
      modalSettings: {
        size: "sm",
      },
      header: `${id ? "Update" : "Create"} Bike/User Scan Trigger`,
      children: (
        <CreateModal
          onCancel={() => this.props.closeCustomModal(modalObj)}
          id={id}
        />
      ),
      handleClose: () => this.props.closeCustomModal(modalObj)
    };
    this.props.openCustomModal(modalObj);
  };

  handleDelete = (id) => {
    this.props.triggerDelete(id);
  };

  handleLoadBike = (qr) => {
    this.props.getSingleBikeByFilters([{
      fieldName: "qr",
      fieldValue: qr,
      searchOperation: filterTypes.EQUALS.value
    }], (bike) => {
      this.props.history.push(`/bikes/${bike.id}`);
    });
  };

  getColumns = () => [
    {
      Header: "#",
      accessor: "id",
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Reason",
      accessor: "reason",
    },
    {
      id: "user-id",
      Header: "UserID",
      accessor: "userId",
      Cell: ({ original }) => {
        if (!original.userId) {
          return null;
        }
        return (
          <Link to={`/users/${original.userId}`}>
            {original.userId}
          </Link>
        );
      }
    },
    {
      id: "bike-qr",
      Header: "Bike QR",
      accessor: "qr",
      Cell: ({ original }) => {
        if (!original.qr) {
          return null;
        }
        return (
          <button className="btn btn-link" onClick={ev => {
            ev.preventDefault();
            this.handleLoadBike(original.qr);
          }}>
            {original.qr}
          </button>
        );
      }
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "Action",
      accessor: "actions",
      Cell: ({ original }) => (
        <div>{(original.actions || []).join(", ")}</div>
      )
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      Cell: ({ original }) => (
        <React.Fragment>
          <button
            className="btn btn-sm btn-warning mr-3"
            onClick={() => this.handleCreate(original.id)}
          >
            <FontAwesomeIcon icon={faPencilAlt}/>
          </button>
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => this.handleDelete(original.id)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-danger">
              <FontAwesomeIcon icon={faTimes}/>
            </button>
          </Popconfirm>
        </React.Fragment>
      )
    },
  ];

  render() {
    const {
      loading,
      bikeLoading,
      list,
    } = this.props;
    const {
      size,
      filters
    } = this.state;

    let pages = 0,
      page = 0;
    if (list && list.content && Array.isArray(list.content)) {
      pages = list.total_pages;
      page = list.page_number;
    }

    return (
      <div className="w-100 p-2">
        <div className="filters">
          <Filters
            activeFilters={filters}
            totalCount={list.total_count || 0}
            handleSearch={this.handleSearch}
            handleReset={this.handleReset}
            handleCreate={() => this.handleCreate()}
          />
        </div>

        <ReactTable
          data={list.content || []}
          headerClassName="table-header"
          columns={this.getColumns()}
          pageSizeOptions={[10, 20, 50, 100]}
          resizable
          className="-striped -highlight table-header-padding"
          loading={loading || bikeLoading}
          filterable={false}
          defaultFilterMethod={filterCaseInsensitive}
          style={{
            height: "calc(100vh - 140px)"
          }}
          manual={true}
          pages={pages}
          page={page}
          pageSize={size}
          onSortedChange={this.handleSortedChange}
          onPageChange={this.handlePageChange}
          onPageSizeChange={this.handlePageSizeChange}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.bikeScanTrigger.loading,
  list: state.bikeScanTrigger.list,
  bike: state.bike.single,
  bikeLoading: state.bike.loading,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  triggerSearch: bindActionCreators(triggerSearch, dispatch),
  triggerDelete: bindActionCreators(triggerDelete, dispatch),
  getSingleBikeByFilters: bindActionCreators(getSingleBikeByFilters, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(BikesScanTrigger);



// WEBPACK FOOTER //
// ./src/views/pages/bikes-scan-trigger/index.js